import capitalize from "lodash/capitalize";

import type { ColumnType, ColumnsType } from "@similarweb/pro-logic-components";
import Sentry from "@similarweb/sentry-logger";

import { translate } from "app/filters/i18nFilter";

import { TOPIC_COLUMN_WIDTH } from "../topics-graph/config";

const TOPIC_COLUMN_WIDTH_WITH_PADDING = TOPIC_COLUMN_WIDTH + 12;

export const getColumnConfig = (selectedBrands: string[]): ColumnsType => {
    try {
        const myBrandsColumn: ColumnType = {
            dataIndex: "myBrands",
            key: "myBrands",
            title: translate("llm.brand.multiple"),
            align: "left",
        };

        const dynamicBrandColumns: Array<ColumnType> = selectedBrands.map((brand) => ({
            dataIndex: brand,
            key: brand,
            title: capitalize(brand),
            align: "left",
        }));

        return [
            {
                disableHeatmap: true,
                dataIndex: "topic",
                key: "topic",
                title: translate("llm.sentiment_report.brand_comparison.widget.column.topic"),
                tooltipSubtitle: translate("llm.sentiment_report.brand_comparison.widget.column.topic.tooltip"),
                align: "left",
                width: TOPIC_COLUMN_WIDTH_WITH_PADDING,
                fixed: true,
                render: (value: string) => value,
            },
            myBrandsColumn,
            ...dynamicBrandColumns,
        ];
    } catch (error) {
        Sentry.errorTracker({
            message: "Error getting column config",
            e: error,
            level: "error",
        });
        return [];
    }
};
